// ----------------------------------------------------------------------

export default function Input(theme) {
    return {
        // Dense by default. An editor form of eight fields at MUI's 56px default
        // came to ~780px and scrolled inside its own dialog; at 40px it fits.
        // Set as a default rather than per component so the ~27 field components
        // do not each need to opt in. The login form opts back out to medium.
        MuiTextField: {
            defaultProps: { size: 'small' },
        },
        MuiFormControl: {
            defaultProps: { size: 'small' },
        },
        MuiAutocomplete: {
            defaultProps: { size: 'small' },
        },
        // The label has to track the input's size or the outlined notch is cut
        // for the wrong width and the floating label sits off the border.
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: theme.typography.pxToRem(14),
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    // MUI's default is body1 at 16px, which made the grid search
                    // and date-range fields the largest type on the page.
                    'fontSize': theme.typography.pxToRem(14),
                    '&.Mui-disabled': {
                        '& svg': { color: theme.palette.text.disabled },
                    },
                },
                input: {
                    '&::placeholder': {
                        opacity: 1,
                        // Not text.disabled: a placeholder is a hint, and has
                        // to be legible (4.5:1) in both themes.
                        color: theme.palette.text.placeholder,
                    },
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                underline: {
                    '&:before': {
                        borderBottomColor: theme.palette.border.underline,
                    },
                },
            },
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    "backgroundColor": theme.palette.fill.input,
                    '&:hover': {
                        backgroundColor: theme.palette.action.selected,
                    },
                    '&.Mui-focused': {
                        backgroundColor: theme.palette.action.focus,
                    },
                    '&.Mui-disabled': {
                        backgroundColor: theme.palette.action.disabledBackground,
                    },
                },
                underline: {
                    '&:before': {
                        borderBottomColor: theme.palette.border.underline,
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.border.input,
                    },
                    '&.Mui-disabled': {
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: theme.palette.action.disabledBackground,
                        },
                    },
                },
            },
        },
    };
}
